import { render } from "./FollowersFollowing.vue?vue&type=template&id=da36b212&scoped=true"
import script from "./FollowersFollowing.vue?vue&type=script&lang=js"
export * from "./FollowersFollowing.vue?vue&type=script&lang=js"

import "./FollowersFollowing.vue?vue&type=style&index=0&id=da36b212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da36b212"]])

export default __exports__